module.exports = __webpack_public_path__ + "static/media/datu8.c6fb0273.png";